import { render, staticRenderFns } from "./CmgRewardsPointsHistory.vue?vue&type=template&id=56b98b9d&scoped=true&lang=pug"
import script from "./cmg-rewards-points-history.ts?vue&type=script&lang=ts&external"
export * from "./cmg-rewards-points-history.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b98b9d",
  null
  
)

export default component.exports